var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "interface-area" },
    [
      _c("WindowModal", {
        attrs: { title: _vm.modalTitle, type: "Global" },
        scopedSlots: _vm._u([
          {
            key: "modal-content",
            fn: function () {
              return [
                _c("ConfirmSwap", {
                  ref: "confirmSwap",
                  attrs: {
                    swap: _vm.swap,
                    "input-method": "exchange",
                    transaction: _vm.transaction,
                  },
                  on: {
                    swapTokens: _vm.exchangeTokens,
                    initConfirmState: function ($event) {
                      return _vm.changeModalTitle("init")
                    },
                    initLoading: function ($event) {
                      return _vm.changeModalTitle("loading")
                    },
                    initSuccess: function ($event) {
                      return _vm.changeModalTitle("success")
                    },
                    initError: function ($event) {
                      return _vm.changeModalTitle("error")
                    },
                    closeGlobalModal: _vm.closeModal,
                    priceRefresh: _vm.loadBalances,
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("div", { staticClass: "swap-box" }, [
        _c("div", { staticClass: "header-area" }, [
          _c("h1", { staticClass: "smaller" }, [
            _vm._v("\n        " + _vm._s(_vm.$t("exchange.h1")) + ":\n      "),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tokens-area" }, [
          _c("div", { staticClass: "token-item" }, [
            _c("div", { staticClass: "form-area" }, [
              _c("div", { staticClass: "input-area" }, [
                _c("label", { attrs: { for: "inputFrom" } }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("swap.from")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.swap.from_value,
                      expression: "swap.from_value",
                    },
                  ],
                  attrs: {
                    id: "inputFrom",
                    type: "number",
                    min: "0",
                    step: "0.0001",
                    lang: "en",
                    placeholder: "0.0...",
                  },
                  domProps: { value: _vm.swap.from_value },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.swap, "from_value", $event.target.value)
                      },
                      _vm.inputFrom,
                    ],
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: {
                      "max-button": true,
                      active:
                        _vm.swap.from_token.balance !== undefined &&
                        parseFloat(_vm.swap.from_token.balance) > 0,
                    },
                    on: { click: _vm.setFromMax },
                  },
                  [
                    _c("p", { staticClass: "text" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("swap.max")) +
                          "\n              "
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "token-select non-interactive" }, [
                _c("p", { staticClass: "desc" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.swap.from_token.name) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "token-data" }, [
                  _c(
                    "div",
                    { staticClass: "token-area" },
                    [
                      _c("nuxt-img", {
                        attrs: {
                          src:
                            "/img/new/" +
                            _vm.swap.from_token.name.toLowerCase() +
                            "_item.svg",
                          placeholder: "",
                          lazy: true,
                        },
                      }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.swap.from_token.symbol) +
                            "\n                "
                        ),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm.swap.from_token.balance !== undefined
              ? _c("p", { staticClass: "available" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("swap.available")) +
                      ":\n          "
                  ),
                  _vm.swap.from_token.balance !== null
                    ? _c("span", { staticClass: "bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$formatCryptoAmount(
                              _vm.swap.from_token.balance,
                              4
                            )
                          )
                        ),
                      ])
                    : _c("span", { staticClass: "bold" }, [_vm._v("0")]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "swap-area" }, [
            _c(
              "div",
              { staticClass: "swap-button", on: { click: _vm.swapInputs } },
              [_c("Swap")],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "token-item" }, [
            _c("div", { staticClass: "form-area" }, [
              _c("div", { staticClass: "input-area" }, [
                _c("label", { attrs: { for: "inputFrom" } }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("swap.to")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.swap.to_value,
                      expression: "swap.to_value",
                    },
                  ],
                  attrs: {
                    id: "inputFrom",
                    type: "number",
                    min: "0",
                    step: "0.0001",
                    lang: "en",
                    placeholder: "0.0...",
                  },
                  domProps: { value: _vm.swap.to_value },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.swap, "to_value", $event.target.value)
                      },
                      _vm.inputTo,
                    ],
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: {
                      "max-button": true,
                      active:
                        _vm.swap.to_token.balance !== undefined &&
                        parseFloat(_vm.swap.to_token.balance) > 0,
                    },
                    on: { click: _vm.setToMax },
                  },
                  [
                    _c("p", { staticClass: "text" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("swap.max")) +
                          "\n              "
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "token-select non-interactive" }, [
                _c("p", { staticClass: "desc" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.swap.to_token.name) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "token-data" }, [
                  _c(
                    "div",
                    { staticClass: "token-area" },
                    [
                      _c("nuxt-img", {
                        attrs: {
                          src:
                            "/img/new/" +
                            _vm.swap.to_token.name.toLowerCase() +
                            "_item.svg",
                          placeholder: "",
                          lazy: true,
                        },
                      }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.swap.to_token.symbol) +
                            "\n                "
                        ),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm.swap.to_token.balance !== undefined
              ? _c("p", { staticClass: "available" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("swap.available")) +
                      ":\n          "
                  ),
                  _vm.swap.to_token.balance !== null
                    ? _c("span", { staticClass: "bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$formatCryptoAmount(
                              _vm.swap.to_token.balance,
                              4
                            )
                          )
                        ),
                      ])
                    : _c("span", { staticClass: "bold" }, [_vm._v("0")]),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { class: { "warning-area": true, active: _vm.errorText.length > 0 } },
          [
            _c("div", { staticClass: "icon-area" }, [_c("Warn")], 1),
            _vm._v(" "),
            _c("div", { staticClass: "text-area" }, [
              _vm._v("\n        " + _vm._s(_vm.errorText) + "\n      "),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { class: { "info-area": true, active: _vm.floatieDelayActive } },
          [
            _c("div", { staticClass: "icon-area" }, [_c("Info")], 1),
            _vm._v(" "),
            _c("div", { staticClass: "text-area" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("exchange.delay", {
                      token: "$FLE",
                      fee: _vm.swap.contract.fee,
                    })
                  ) +
                  "\n        "
              ),
              _c("span", { staticClass: "bold" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.calculateDate(
                        _vm.swap.contract.floatieDelay +
                          _vm.swap.contract.scheduleFloatieDelay
                      )
                    ) +
                    "\n        "
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { class: { "info-area": true, active: _vm.splashieDelayActive } },
          [
            _c("div", { staticClass: "icon-area" }, [_c("Info")], 1),
            _vm._v(" "),
            _c("div", { staticClass: "text-area" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("exchange.delay", {
                      token: "$PHE",
                      fee: _vm.swap.contract.fee,
                    })
                  ) +
                  "\n        "
              ),
              _c("span", { staticClass: "bold" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.calculateDate(
                        _vm.swap.contract.splashieDelay +
                          _vm.swap.contract.scheduleSplashieDelay
                      )
                    ) +
                    "\n        "
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "buttons-area" }, [
          _vm.user !== undefined && _vm.user !== null
            ? _c(
                "button",
                {
                  class: {
                    "btn cyan": true,
                    disabled:
                      !_vm.tokensPicked || _vm.loading || _vm.swapInsufficient,
                  },
                  attrs: {
                    type: "button",
                    disabled:
                      !_vm.tokensPicked || _vm.loading || _vm.swapInsufficient,
                  },
                  on: { click: _vm.prepareSwap },
                },
                [
                  !_vm.loading
                    ? _c("span", [
                        _vm._v(
                          "\n          " + _vm._s(_vm.swapCta) + "\n        "
                        ),
                      ])
                    : _c("span", [_c("Loading")], 1),
                ]
              )
            : _c(
                "button",
                {
                  staticClass: "btn cyan",
                  on: { click: _vm.openConnectModal },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("common.connect_wallet")) +
                      "\n      "
                  ),
                ]
              ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cyan-cloud" },
        [_c("CloudCyanLiquidityLeft")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cyan-cloud2" },
        [_c("CloudCyanLiquidityRight")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }